import { render, staticRenderFns } from "./datasearch.vue?vue&type=template&id=03f4855e&scoped=true&"
import script from "./datasearch.vue?vue&type=script&lang=js&"
export * from "./datasearch.vue?vue&type=script&lang=js&"
import style0 from "./datasearch.vue?vue&type=style&index=0&id=03f4855e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f4855e",
  null
  
)

export default component.exports